import React from 'react';
import {Box, Chip, Tooltip, Typography} from '@mui/material';
import {pastilleDistances, pastilleDistancesCourte} from './atelierRules';

/** Pilule « Distances : routier (OSRM) » ou « vol d'oiseau × 1,3 » (+ aide) sous le verdict ; rien si `totaux.distances` est absent. */
function PiluleDistances({distances, sx, courte = false}) {
    if (courte) {
        // Lot 9 : version du bandeau de l'atelier, une pastille sans retour à la ligne, libellé complet en infobulle.
        const c = pastilleDistancesCourte(distances);
        if (!c) return null;
        return (
            <Tooltip title={c.infobulle} arrow>
                <Chip size="small" data-testid="distances" data-etat={c.etat} label={c.libelle}
                      sx={{flex: 'none', fontWeight: 700, bgcolor: c.etat === 'osrm' ? '#E7ECF6' : '#FDEBD8', color: c.etat === 'osrm' ? '#0F2D69' : '#B8641A', ...sx}}/>
            </Tooltip>
        );
    }
    const p = pastilleDistances(distances);
    if (!p) return null;
    return (
        <Box data-testid="distances" data-etat={p.etat} sx={{display: 'flex', alignItems: 'center', gap: 1, flexWrap: 'wrap', ...sx}}>
            <Chip size="small" label={p.libelle} sx={{fontWeight: 700, bgcolor: p.aide ? '#FDEBD8' : '#E7ECF6', color: p.aide ? '#B8641A' : '#0F2D69'}}/>
            {p.aide && <Typography variant="caption" sx={{color: '#5A6470', fontWeight: 600}}>{p.aide}</Typography>}
        </Box>
    );
}

export default PiluleDistances;
